import { mapRecommendedPackage } from './recommendedPackages';
import { defaultTo } from 'ramda';
import { mapMoneySources, mapPaidPublication, mapPromotion } from './mapPublishTermsV1ToV2';
import { mapPublicationPackages } from './mapPublicationPackages';
import { IAddFormPublishTermsResponse } from '../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { IPublishTermsSuccessPayload } from '../../../../actions/publishTerms';

export const mapPublishTerms = (response: IAddFormPublishTermsResponse): IPublishTermsSuccessPayload => {
  const rawRecommendedPackages = defaultTo([], response.recommendedServicePackages);

  const recommendedPackages = rawRecommendedPackages.map(mapRecommendedPackage);

  return {
    dataV2: {
      paidPublication: mapPaidPublication(response),
      recommendedPackages,
      publicationPackages: mapPublicationPackages(defaultTo([], response.servicePackages)),
      promotion: mapPromotion(response),
      moneySources: mapMoneySources(response),
    },
  };
};
